function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatLstApi, attachmentCreateApi, attachmentUpdateApi, picNameEditApi, attachmentDeleteApi, attachmentListApi, picDeleteApi, categoryApi } from '@/api/system';
import { VueTreeList } from 'vue-tree-list';
import { getToken as _getToken } from '@/utils/auth';
import SettingMer from '@/libs/settingMer';
import Tips from '@/utils/tips';
import compressImg from '@/utils/compressImg';
export default {
  name: 'uploadPictures',
  components: {
    VueTreeList: VueTreeList,
    ElImageViewer: function ElImageViewer() {
      return import('element-ui/packages/image/src/image-viewer');
    }
  },
  props: {
    isChoice: {
      type: String,
      default: ''
    },
    isPage: {
      type: Boolean,
      default: false
    },
    isIframe: {
      type: Boolean,
      default: false
    },
    gridBtn: {
      type: Object,
      default: null
    },
    gridPic: {
      type: Object,
      default: null
    },
    isShow: {
      type: Number,
      default: 1
    },
    pageLimit: {
      type: Number,
      default: 0
    },
    maxNum: {
      type: Number,
      default: 0
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      spinShow: false,
      fileUrl: "".concat(SettingMer.https, "/system/attach/upload"),
      modalPic: false,
      treeData: [],
      treeData2: [],
      pictrueList: [],
      uploadData: {},
      // 上传参数
      checkPicList: [],
      uploadName: {
        name: '',
        all: 1
      },
      formValidate: {
        id: 0
      },
      FromData: null,
      treeId: '',
      isJudge: false,
      buttonProps: {
        type: 'default',
        size: 'small'
      },
      fileData: {
        cid: 0,
        real_name: '',
        page: 1,
        limit: this.pageLimit || 24
      },
      total: 0,
      pids: 0,
      list: [],
      modalTitleSs: '',
      isShowPic: false,
      header: {},
      ids: [],
      // 选中附件的id集合
      lietStyle: 'list',
      imageUrl: '',
      loading: false,
      multipleSelection: [],
      picmargin: '5px',
      //默认距离右边距离
      isImage: false,
      imgList: [],
      imgIndex: 0,
      ruleForm: {
        type: 0,
        region: '',
        imgList: []
      },
      limit: 20
    };
  },
  mounted: function mounted() {
    if (this.isPage) {
      var hang = parseInt((document.body.clientHeight - this.$refs.imgListBox.clientHeight - 325) / 180); //计算行数
      var col = parseInt(this.$refs.imgListBox.clientWidth / 156); //计算列数
      this.fileData.limit = col * hang; //计算分页数量
      this.picmargin = parseInt(this.$refs.imgListBox.clientWidth - col * 146) / (2 * col) + 'px'; //平均分布计算margin距离
    }
    this.getToken();
    this.getList();
    this.getFileList();
  },
  methods: {
    radioChange: function radioChange() {
      this.initData();
    },
    fileChange: function fileChange(file, fileList) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(file.size >= 2097152)) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return _this.comImg(file.raw).then(function (res) {
                fileList.map(function (e) {
                  if (e.uid === file.uid) {
                    e.raw = res;
                  }
                });
                _this.ruleForm.imgList = fileList;
              });
            case 3:
              _context.next = 6;
              break;
            case 5:
              _this.ruleForm.imgList = fileList;
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    comImg: function comImg(file) {
      return new Promise(function (resolve, reject) {
        compressImg(file).then(function (res) {
          resolve(res);
        });
      });
    },
    onDel: function onDel(node) {
      var _this2 = this;
      var method = node.cate_id ? routeDel : routeCateDel;
      this.$msgbox({
        title: '提示',
        message: '是否确定删除该菜单',
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '删除',
        iconClass: 'el-icon-warning',
        confirmButtonClass: 'btn-custom-cancel'
      }).then(function () {
        method(node.id).then(function (res) {
          _this2.$message.success(res.msg);
          node.remove();
        }).catch(function (err) {
          _this2.$message.error(err);
        });
      }).catch(function () {});
    },
    // 添加分类
    addSort: function addSort() {
      this.append({
        id: this.treeId || 0
      });
    },
    // 点击菜单
    clickMenu: function clickMenu(data, name) {
      if (name == 1) {
        this.append(data);
      } else if (name == 2) {
        this.editPic(data);
      } else if (name == 3) {
        this.remove(data, '分类');
      }
    },
    uploadSuccess: function uploadSuccess() {
      this.fileData.page = 1;
      this.initData();
      this.getFileList();
    },
    uploadModal: function uploadModal() {
      this.$refs.upload.uploadModal = true;
    },
    enterMouse: function enterMouse(item) {
      item.realName = !item.realName;
    },
    enterLeave: function enterLeave(item) {
      item.isShowEdit = !item.isShowEdit;
    },
    // 上传头部token
    getToken: function getToken() {
      this.header['Authorization'] = 'Bearer ' + _getToken();
    },
    moveImg: function moveImg(status) {
      if (!status) {
        this.getMove();
      } else {
        if (!this.ids.toString()) {
          this.$message.warning('请先选择图片');
          return;
        }
      }
    },
    searchImg: function searchImg() {},
    // 移动分类
    getMove: function getMove() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                pid: _this3.pids,
                images: _this3.ids.toString()
              };
              if (data.images) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _context2.next = 5;
              return categoryApi(data);
            case 5:
              _context2.next = 7;
              return _this3.getFileList();
            case 7:
              _this3.pids = 0;
              _this3.checkPicList = [];
              _this3.ids = [];
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    delImg: function delImg(id) {
      var _this4 = this;
      var ids = {
        ids: id
      };
      var delfromData = {
        title: '删除选中图片',
        url: "file/file/delete",
        method: 'POST',
        ids: ids
      };
      this.$modalSure(delfromData).then(function (res) {
        _this4.$message.success(res.msg);
        _this4.getFileList();
        _this4.checkPicList = [];
      }).catch(function (res) {
        _this4.$message.error(res.msg);
      });
    },
    // 删除图片
    editPicList: function editPicList(id) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var ids;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              ids = {
                ids: id || _this5.ids.toString()
              };
              _context3.next = 3;
              return Tips.confirm({
                message: '此操作将永久删除该文件, 是否继续?'
              });
            case 3:
              _context3.next = 5;
              return picDeleteApi(ids);
            case 5:
              _context3.next = 7;
              return _this5.getFileList();
            case 7:
              _context3.next = 9;
              return _this5.initData();
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      this.checkPicList = [];
      this.ids = [];
      this.multipleSelection = [];
    },
    // 鼠标移入 移出
    onMouseOver: function onMouseOver(root, node, data) {
      event.preventDefault();
      data.flag = !data.flag;
      if (data.flag2) {
        data.flag2 = false;
      }
    },
    // 点击树
    appendBtn: function appendBtn(data) {
      this.treeId = data.id;
      this.fileData.page = 1;
      this.getFileList();
    },
    // 点击添加
    append: function append(data) {
      this.treeId = data.id;
      this.getFrom();
    },
    // 删除分类
    remove: function remove(data, tit) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return Tips.confirm({
                message: '此操作将永久删除 [ ' + data.cate_name + ' ] ' + '分类, 是否继续?'
              });
            case 2:
              _context4.next = 4;
              return attachmentDeleteApi(data.id);
            case 4:
              _this6.checkPicList = [];
              _context4.next = 7;
              return _this6.getList();
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    // 编辑树表单
    editPic: function editPic(data) {
      var _this7 = this;
      this.$modalForm(attachmentUpdateApi(data.id)).then(function () {
        return _this7.getList();
      });
    },
    // 搜索分类
    changePage: function changePage() {
      this.getList('search');
    },
    // 分类列表树
    getList: function getList(type) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var data, res;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              data = {
                cate_name: '全部图片',
                id: '',
                pid: 0
              };
              _context5.next = 3;
              return formatLstApi(_this8.uploadName);
            case 3:
              res = _context5.sent;
              if (type !== 'search') {
                _this8.treeData2 = JSON.parse(JSON.stringify(_toConsumableArray(res.data)));
              }
              res.data.unshift(data);
              _this8.treeData = res.data;
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    loadData: function loadData(item, callback) {
      attachmentListApi({
        pid: item.id
      }).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6(res) {
          var data;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                data = res.data.list;
                callback(data);
              case 2:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {});
    },
    addFlag: function addFlag(treedata) {
      var _this9 = this;
      treedata.map(function (item) {
        _this9.$set(item, 'flag', false);
        _this9.$set(item, 'flag2', false);
        item.children && _this9.addFlag(item.children);
      });
    },
    // 新建分类
    add: function add() {
      this.treeId = 0;
      this.getFrom();
    },
    // 文件列表
    getFileList: function getFileList() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var res;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this10.fileData.cid = _this10.treeId;
              _this10.imgList = [];
              _context7.next = 4;
              return attachmentListApi(_this10.fileData);
            case 4:
              res = _context7.sent;
              res.data.list.forEach(function (el) {
                el.isSelect = false;
                el.isEdit = false;
                el.isShowEdit = false;
                el.realName = false;
                el.num = 0;
                _this10.editName(el);
                _this10.imgList.push(el.att_dir);
              });
              _this10.pictrueList = res.data.list;
              if (_this10.pictrueList.length) {
                _this10.isShowPic = false;
              } else {
                _this10.isShowPic = true;
              }
              _this10.total = res.data.count;
              _this10.$nextTick(function () {
                //确保dom加载完毕
                // this.showSelectData();
              });
            case 10:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    handlePictureCardPreview: function handlePictureCardPreview(item) {
      var _this11 = this;
      this.$nextTick(function () {
        _this11.imgIndex = _this11.pictrueList.findIndex(function (e) {
          return e.att_dir === item.att_dir;
        });
      });
      this.isImage = true;
    },
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
    },
    showSelectData: function showSelectData() {
      var _this12 = this;
      if (this.multipleSelection.length > 0) {
        // 判断是否存在勾选过的数据
        this.pictrueList.forEach(function (row) {
          // 获取数据列表接口请求到的数据
          _this12.multipleSelection.forEach(function (item) {
            // 勾选到的数据
            if (row.att_id === item.id) {
              // this.$refs.table.toggleRowSelection(item, true); // 若有重合，则回显该条数据
            }
          });
        });
      }
    },
    getRowKey: function getRowKey(row) {
      return row.att_id;
    },
    //对象数组去重；
    unique: function unique(arr) {
      return arr.reduce(function (acc, curr) {
        var x = acc.find(function (item) {
          return item.att_id === curr.att_id;
        });
        if (!x) {
          return acc.concat([curr]);
        } else {
          return acc;
        }
      }, []);
    },
    //  选中某一行
    handleSelectRow: function handleSelectRow(selection) {
      var arr = this.unique(selection);
      var uniqueArr = [];
      var ids = [];
      for (var i = 0; i < arr.length; i++) {
        var item = arr[i];
        if (!ids.includes(item.att_id)) {
          uniqueArr.push(item);
          ids.push(item.att_id);
        }
      }
      this.ids = ids;
      this.multipleSelection = uniqueArr;
    },
    pageChange: function pageChange(index) {
      this.fileData.page = index;
      this.getFileList();
      this.checkPicList = [];
    },
    // 新建分类表单
    getFrom: function getFrom() {
      var _this13 = this;
      this.$modalForm(attachmentCreateApi({
        id: this.treeId
      })).then(function (res) {
        _this13.getList();
      });
    },
    // 上传之前
    beforeUpload: function beforeUpload(file) {
      var _this14 = this;
      if (!/image\/\w+/.test(file.type)) {
        this.$message.error('请上传以jpg、jpeg、png等结尾的图片文件'); //FileExt.toLowerCase()
        return false;
      }
      this.uploadData = {
        cid: this.treeId
      };
      return new Promise(function (resolve) {
        _this14.$nextTick(function () {
          resolve(true);
        });
      });
    },
    // 上传成功
    handleSuccess: function handleSuccess(res, file, fileList) {
      if (res.status === 200) {
        this.$message.success(res.msg);
        this.fileData.page = 1;
        this.getFileList();
      } else {
        this.$message.error(res.msg);
      }
    },
    // 关闭
    cancel: function cancel() {
      this.$emit('changeCancel');
    },
    // 选中图片
    changImage: function changImage(item, index, row) {
      var _this15 = this;
      var activeIndex = 0;
      if (!item.isSelect) {
        item.isSelect = true;
        this.checkPicList.push(item);
      } else {
        item.isSelect = false;
        this.checkPicList.map(function (el, index) {
          if (el.id == item.id) {
            activeIndex = index;
          }
        });
        this.checkPicList.splice(activeIndex, 1);
      }
      this.ids = [];
      this.checkPicList.map(function (item, i) {
        _this15.ids.push(item.id);
      });
      this.pictrueList.map(function (el, i) {
        if (el.isSelect) {
          _this15.checkPicList.filter(function (el2, j) {
            if (el.id == el2.id) {
              el.num = j + 1;
            }
          });
        } else {
          el.num = 0;
        }
      });
    },
    // 点击使用选中图片
    checkPics: function checkPics() {
      if (this.$route && this.$route.query.field) {
        if (this.checkPicList.length > 1) {
          return this.$message.warning('最多只能选一张图片');
        }
        form_create_helper.set(this.$route.query.field, this.checkPicList[0].att_dir);
        form_create_helper.close(this.$route.query.field);
      }
      if (this.maxNum > 0) {
        if (this.checkPicList.length > this.maxNum) return this.$message.warning('最多只能选' + this.maxNum + '张图片');
        this.$emit('getImage', this.checkPicList);
      } else if (this.multiple) {
        var maxLength = this.$route.query.maxLength;
        if (maxLength !== undefined && this.checkPicList.length > Number(maxLength)) return this.$message.warning('最多只能选' + maxLength + '张图片');
        this.$emit('getImage', this.checkPicList);
      } else {
        if (this.checkPicList.length > 1) return this.$message.warning('最多只能选一张图片');
        this.$emit('getImage', this.checkPicList[0]);
      }
    },
    editName: function editName(item) {
      var it = item.real_name.split('.');
      var it1 = it[1] == undefined ? [] : it[1];
      var len = it[0].length + it1.length;
      item.editName = len < 10 ? item.real_name : item.real_name.substr(0, 4) + '...' + item.real_name.substr(-5, 5);
    },
    // 修改图片名称
    bindTxt: function bindTxt(item) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!item.real_name) {
                _this16.$message.error('请填写名称内容');
              }
              _context8.next = 3;
              return picNameEditApi(item.id, {
                real_name: item.real_name
              });
            case 3:
              _context8.next = 5;
              return _this16.editName(item);
            case 5:
              item.isEdit = false;
            case 6:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    }
  }
};